import * as _ from 'lodash'
import { Table, THead, TR, TH, TD, TBody, ElementProperties, not, all } from 'alkali'
import GroupsModel from './model/GroupsModel'
import {
	Mode,
	GroupsContext,
	groupRows,
	interventionCells,
	interventionOpCells,
	AddGroupRow,
	groupState,
	groupStatusMsgOnly
} from './GroupComponents'
import Icon from 'components/Icon'
import * as multipleUsers from 'icons/multiple-circle.svg'
import { VGroup } from 'components/extract/model/extraction'

interface GroupsMgmtTableOpts extends ElementProperties<GroupsMgmtTable> {
	groupsModel: GroupsModel
}

const SpacerRow = TR.with({
	created(props) {
		props.content = [
			TD('.spacer-row'),
			TD(),
			TD(),
			TD({ classes: { hidden: not(props.showItvnOp) } }),
			TD('.group-n-cell'),
		]
	}
})

/**
 * Management interface for editing groups themselves
 */
export default class GroupsMgmtTable extends Table('.groups-table') {
	private groupsModel: GroupsModel

	created(props: GroupsMgmtTableOpts) {
		const { groupsModel } = props
		const { groups, study: studyCtx } = groupsModel
		const groupsContext: GroupsContext = { studyCtx, groups, canAddGroup: false }
		const showItvnOp = groups.to(groups => _.some(groups, g => g.interventions?.length > 1))
		const itvnOpRowColSpan = showItvnOp.to(addtlCol => +addtlCol)
		props.content = groups.map((group: VGroup) => {
			const state = groupState(group.to(g => g.existing ? Mode.EDIT : Mode.ADD), groupsContext, group)
			const itvnCells = group.interventions.map(intervention =>
				interventionCells(intervention, group.interventions, undefined, not(showItvnOp), state)
			)
			
			//check for errors to display
			const statusMsg = groupStatusMsgOnly(group)

			return groupRows({ groupsContext, group, itvnCells }, state, false).to(rows =>
				TBody('.group-table-row', [
					SpacerRow({ showItvnOp }),
					...rows,
					TR('.op-row', interventionOpCells(group, itvnOpRowColSpan, state, statusMsg))
				]))
		}).to(rows => {
			return all(rows)
		}).to(rows => [
			THead([
				TR([
					TH({ attributes: { scope: 'col' }, title: 'Group' }),
					TH({ attributes: { scope: 'col' } }, 'Intervention'),
					TH('.dosage-hdr', { attributes: { scope: 'col' } }, 'Dosage'),
					TH({ attributes: { scope: 'col' }, classes: { hidden: not(showItvnOp) } }),
					//TH('.group-n-hdr', { attributes: { scope: 'col' } }, 'Group N'),
				])
			]),
			...rows.flat(),
			// can't use transform here or last row gets duplicated each time groups is updated
			AddGroupRow(groupsContext)
		])
	}
}